<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <br/>
        <br/>
        <div>
          <CaptionWhite label="진행 중인 프로젝트"></CaptionWhite>
        </div>
        <div class="text mobile" >
          <br/>
          계약 후 5일 이내
          <br />첫 구동 버전을 
          <br />직접 확인하실 수 있습니다
        </div>
        <div class="text pc">
          <br />
          계약 후 5일 이내, 첫 구동 버전을 직접 확인하실 수 있습니다
        </div>

        <div style="text-align: center; display: flex; justify-content: center; padding-bottom: 30px;">
          <ul>
            <li v-for="m of project_list" class="card_bg">
              <div class="project_name">
                {{ m.name }}
              </div>
              <p class="project_sub_title">
                {{ m.sub_title }}
              </p>
              <p class="project_desc">
                {{ m.desc }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
  
<script>
import Caption from "../components/Caption.vue";
import CaptionWhite from "../components/CaptionWhite.vue";
import client from "../client/client";

export default {
  components: {
    Caption,
    CaptionWhite,
  },
  data() {
    return {
      project_list: [{}, {}, {}],
    };
  },

  mounted() {
    client
      .get("/api/project/list")
      .then((res) => {
        this.project_list = res.list;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 450px;
  position: relative;
  overflow: hidden;
  background-color: #215fe6;
  padding-bottom: 50px;
  padding-left: 20px;
  padding-right: 20px;
}

.content {
  width: 1140px;
  max-width: 1140px;
  text-align: center;
}

ul {
  margin-top: 40px;
  width: 100%;
  height: 180px;
  list-style-type: none;
  white-space: nowrap;
  overflow-x: scroll;
  padding-inline-start: 0px;
}
li.card_bg:not(:last-child) {
  margin-right: 13px;
  margin-bottom: 0px;
}

ul li {
  display: inline-block;
}

.text {
  color: #ffffff;
  font-size: 34px;
  font-weight: 700;
  margin-top: 35px;
}

.card_bg {
  padding: 20px;
  text-align: left;
  width: 352px;
  height: auto;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}

.project_name {
  display: block;
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
  color: #111111;
}

.project_sub_title {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.45;
  color: #5d5d5d;
}

.project_desc {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
  color: #2f2f2f;
  white-space: normal;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    justify-content: center;
    width: 100vw;
    height: fit-content;
    position: relative;
    overflow: hidden;
    background-color: #215fe6;
  }

  .content {
    width: 100%;
    text-align: center;
  }

  ul {
    width: fit-content;
    height: fit-content;
    list-style-type: none;
    overflow: hidden;
    overflow-y: scroll;
    padding-inline-start: 0px;
  }

  li.card_bg:not(:last-child) {
    margin-right: 0px;
    margin-bottom: 15px;
  }

  ul li {
    display: block;
  }

  .text {
    color: #ffffff;
    font-size: 30px;
    font-weight: 700;
    margin-top: 15px;
  }

  .card_bg {
    padding: 20px;
    text-align: left;
    width: 80vw;
    height: auto;
    background: #ffffff;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
    border-radius: 16px;
  }
}

</style>
  